// Number of reviews to show per page
var perPage = window.review_details[0].perPage;
var productSku = window.review_details[0].productSku;
var productName = window.review_details[0].productName;
var pagination = false;
var page = 1;
var firstLoad = true;
var stars = "";
var media = "";
var searchStr = "";

$(document).ready(function () {
  if (window.location.href.indexOf("#") > -1) {
    var anchor = window.location.href.split('#')[1];
    if (!isNaN(anchor))
      page = window.location.href.split('#')[1];
  }

  if (productSku == "site") {
    getSiteReviews(page, stars);
  } else {
    $('#product-tabs button').removeClass('active').removeAttr('disabled');
    $('#product-tabs button[value="' + productSku + '"]').addClass('active').attr('disabled', true);
    $('#product-filter').val(productSku);
    getProductReviews(productSku, page, stars);
  }

  $('#product-tabs button').on('click', function () {
    selectProduct(this);
  });

  $('#product-filter').on('change', function () {
    selectProduct(this);
  });

  $('#rating-filter, #media-filter').on('change', function () {
    if ($(this).is('#rating-filter') && $(this).val() > 0) {
      $(this).css({ 'font-size': '1.5rem', 'color': '#fec600' });
    } else {
      $(this).css({ 'font-size': '1rem', 'color': '#222' });
    }

    resetSearch();
    page = 1;
    resetContent().then(setTimeout(function () {
      history.pushState("", document.title, window.location.pathname);
      stars = $('#rating-filter').val();
      media = $('#media-filter').val();
      if (productSku == "site") {
        if (media > 0) {
          getSiteReviewsAndFilter(page, stars, media, searchStr);
        } else {
          getSiteReviews(page, stars);
        }
      } else {
        if (media > 0) {
          getProductReviewsAndFilter(productSku, page, stars, media, searchStr, false);
        } else {
          getProductReviews(productSku, page, stars);
        }
      }
    }, 10));
  });

  $('#search-filter').keypress(function (e) {
    if (e.which == 13) {
      resetFilters();
      page = 1;
      resetContent().then(setTimeout(function () {
        searchStr = $('#search-filter').val().toLowerCase();
        if (productSku == "site") {
          getSiteReviewsAndFilter(page, stars, media, searchStr);
        } else {
          getProductReviewsAndFilter(productSku, page, stars, media, searchStr, false);
        }
        history.pushState("", document.title, window.location.pathname);
      }, 10));
      return false;
    }
  });

  $('#clear-filters').on('click', function () {
    resetFilters();
    resetSearch();
    if (productSku == "site") {
      getSiteReviews(page, stars);
    } else {
      resetContent().then(setTimeout(function () {
        getProductReviews(productSku, page, stars);
      }, 10));
    }
  });
});

$(document).ajaxComplete(function () {
  buttonControls();
});

function getSiteReviews(page, stars) {
  resetContent();
  // Yotpo Reviews API
  if (stars == "" || stars == null) {
    var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/yotpo_site_reviews/reviews.json?per_page=" + perPage + "&page=" + page });
  } else {
    var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/yotpo_site_reviews/reviews.json?per_page=" + perPage + "&page=" + page + "&star=" + stars });
  }

  getReviews.done(function (data) {
    $('#ajax-loading').hide();
    $('#main-content').show();
    var bottomLine = data['response']['bottomline'];
    page = data['response']['pagination']['page'];
    var searchOrFilter = "site";

    // Use star_distribution total when filtering by score
    if (stars > 0) {
      var totalReviews = bottomLine['star_distribution'][stars];
    } else {
      var totalReviews = data['response']['pagination']['total'];
    }
    var queriedReviews = data['response']['reviews'];

    for (i = 0; i < queriedReviews.length; i++) {
      buildReview(queriedReviews[i]);
    }

    buildPagination(page, totalReviews, searchOrFilter);

    buildBottomLine(bottomLine, totalReviews, false);
  }).fail(function () {
    buildFailure();
  });
  resetSearch();
}

function getProductReviews(productSku, page, stars) {
  resetContent();

  // Yotpo Reviews API
  if (stars == "" || stars == null) {
    var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/" + productSku + "/reviews.json?per_page=" + perPage + "&page=" + page });
  } else {
    var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/" + productSku + "/reviews.json?per_page=" + perPage + "&page=" + page + "&star=" + stars });
  }

  getReviews.done(function (data) {
    $('#ajax-loading').hide();
    $('#main-content').show();
    var bottomLine = data['response']['bottomline'];
    page = data['response']['pagination']['page'];
    var searchOrFilter = "product";

    // Use star_distribution total when filtering by score
    if (stars > 0) {
      var totalReviews = bottomLine['star_distribution'][stars];
    } else {
      var totalReviews = data['response']['pagination']['total'];
    }
    var queriedReviews = data['response']['reviews'];

    for (i = 0; i < queriedReviews.length; i++) {
      buildReview(queriedReviews[i]);
    }

    buildPagination(page, totalReviews, searchOrFilter);

    buildBottomLine(bottomLine, totalReviews, false);
  }).fail(function () {
    buildFailure();
  });
  resetSearch();
}

function getProductReviewsAndFilter(productSku, page, stars, media, searchStr) {
  var totalReviews = 0;
  var reviewsOnCurrentPage = 0;
  var bottomLine = "";
  var bottomLineAverage = 0;
  var bottomLineTotal = 0;
  var totalReviewsInQuery = 0;
  var allReviews = [];
  var filteredReviews = [];
  var sku = "";
  var searchOrFilter = "filtered_product";

  // Get reviews for each SKU belonging to the product (no longer necessary, only 1 sku now)
  var totalReviewsFiltered = 0;
  var reviewsRemaining = true;

  // Get reviews for the SKU - need to call ajax repeatedly incrementing pagination
  for (i = 0; reviewsRemaining; i++) {
    var apiPage = i + 1;

    // Yotpo Reviews API
    if (stars == "" || stars == null) {
      var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/" + productSku + "/reviews.json?per_page=150&page=" + apiPage, async: false });
    } else {
      var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/" + productSku + "/reviews.json?per_page=150&page=" + apiPage + "&star=" + stars, async: false });
    }

    getReviews.done(function (data) {
      $('#ajax-loading').hide();
      $('#main-content').show();

      var bottomLineQuery = data['response']['bottomline'];
      bottomLine = bottomLineQuery;

      // Use star_distribution total when filtering by score
      // Add to the total for each sub-product to get total for the product
      if (stars > 0) {
        totalReviewsInQuery = bottomLineQuery['star_distribution'][stars];
      } else {
        totalReviewsInQuery = data['response']['pagination']['total'];
      }

      var queriedReviews = data['response']['reviews'];
      totalReviews = totalReviews + queriedReviews.length;
      totalReviewsFiltered = totalReviewsFiltered + queriedReviews.length;
      if (totalReviewsFiltered >= totalReviewsInQuery || queriedReviews.length === 0)
        reviewsRemaining = false;

      for (a = 0; a < queriedReviews.length; a++) {
        allReviews.push(queriedReviews[a]);
      }
    }).fail(function () {
      buildFailure();
    });
  }
  bottomLineAverage = bottomLine['average_score'];
  bottomLineTotal = bottomLine['total_review'];

  // Filter for search
  if (searchStr.length) {
    for (i = 0; i < allReviews.length; i++) {
      var titleStr = allReviews[i]['title'].toLowerCase();
      var contentStr = allReviews[i]['content'].toLowerCase();
      var text = titleStr.concat(contentStr);
      var result = kmpSearch(searchStr, text);
      if (result > -1) {
        filteredReviews.push(allReviews[i]);
      }
    }
  }
  // Filter for images
  else if (media > 0) {
    if (allReviews.some(r => r.hasOwnProperty('images_data') && r.images_data != null)) {
      for (i = 0; i < allReviews.length; i++) {
        if (allReviews[i].hasOwnProperty('images_data') && allReviews[i].images_data != null) {
          filteredReviews.push(allReviews[i]);
        }
      }
    }
  } else {
    filteredReviews = allReviews;
  }

  // Sort by time
  filteredReviews.sort(function (a, b) {
    var timeA = a.created_at;
    var timeB = b.created_at;
    if (timeA > timeB) {
      return -1;
    }
    if (timeA < timeB) {
      return 1;
    }
    return 0;
  });
  // Then sort by rating
  if (stars == "" || stars == null) {
    filteredReviews.sort(function (a, b) {
      return b.score - a.score;
    });
  }

  for (i = 0; i < filteredReviews.length; i++) {
    if (reviewsOnCurrentPage >= perPage * page - perPage && reviewsOnCurrentPage < perPage * page)
      buildReview(filteredReviews[i]);
    reviewsOnCurrentPage++;
  }

  if (filteredReviews.length == 0)
    buildNoReviews();

  buildPagination(page, filteredReviews.length, searchOrFilter);

  bottomLine['total_review'] = bottomLineTotal;
  bottomLine['average_score'] = bottomLineAverage;
  buildBottomLine(bottomLine, filteredReviews.length);

  buttonControls();
}

function getSiteReviewsAndFilter(page, stars, media, searchStr) {
  var totalReviews = 0;
  var reviewsOnCurrentPage = 0;
  var bottomLine = "";
  var allReviews = [];
  var filteredReviews = [];
  var totalReviewsFiltered = 0;
  var reviewsRemaining = true;
  var searchOrFilter = "filter";

  // Get all site reviews - need to call ajax repeatedly incrementing pagination
  for (i = 0; reviewsRemaining; i++) {
    var apiPage = i + 1;

    // Yotpo Reviews API
    if (stars == "" || stars == null) {
      var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/yotpo_site_reviews/reviews.json?per_page=150&page=" + apiPage, async: false });
    } else {
      var getReviews = $.ajax({ type: "GET", url: "https://api-cdn.yotpo.com/v1/widget/bvz16QxLHInYlxLPWNOwNBz2fi5Q1kyBIR91kxzI/products/yotpo_site_reviews/reviews.json?per_page=150&page=" + apiPage + "&star=" + stars, async: false });
    }

    getReviews.done(function (data) {
      $('#ajax-loading').hide();
      $('#main-content').show();

      bottomLine = data['response']['bottomline'];

      // Use star_distribution total when filtering by score
      if (stars > 0) {
        totalReviews = bottomLine['star_distribution'][stars];
      } else {
        totalReviews = data['response']['pagination']['total'];
      }
      var queriedReviews = data['response']['reviews'];
      totalReviewsFiltered = totalReviewsFiltered + queriedReviews.length;
      if (totalReviewsFiltered >= totalReviews || queriedReviews.length === 0)
        reviewsRemaining = false;

      for (a = 0; a < queriedReviews.length; a++) {
        allReviews.push(queriedReviews[a]);
      }

    }).fail(function () {
      buildFailure();
    });
  }

  // Filter for search
  if (searchStr.length) {
    for (i = 0; i < allReviews.length; i++) {
      var titleStr = allReviews[i]['title'].toLowerCase();
      var contentStr = allReviews[i]['content'].toLowerCase();
      var text = titleStr.concat(contentStr);
      var result = kmpSearch(searchStr, text);
      if (result > -1) {
        filteredReviews.push(allReviews[i]);
      }
    }
  }
  // Filter for images
  else if (media > 0) {
    if (allReviews.some(r => r.hasOwnProperty('images_data') && r.images_data != null)) {
      for (i = 0; i < allReviews.length; i++) {
        if (allReviews[i].hasOwnProperty('images_data') && allReviews[i].images_data != null) {
          filteredReviews.push(allReviews[i]);
        }
      }
    }
  } else {
    filteredReviews = allReviews;
  }

  // Sort by time
  filteredReviews.sort(function (a, b) {
    var timeA = a.created_at;
    var timeB = b.created_at;
    if (timeA > timeB) {
      return -1;
    }
    if (timeA < timeB) {
      return 1;
    }
    return 0;
  });
  // Then sort by rating
  if (stars == "" || stars == null) {
    filteredReviews.sort(function (a, b) {
      return b.score - a.score;
    });
  }

  for (i = 0; i < filteredReviews.length; i++) {
    if (reviewsOnCurrentPage >= perPage * page - perPage && reviewsOnCurrentPage < perPage * page)
      buildReview(filteredReviews[i]);
    reviewsOnCurrentPage++;
  }

  if (filteredReviews.length == 0)
    buildNoReviews();

  buildPagination(page, filteredReviews.length, searchOrFilter);

  buildBottomLine(bottomLine, filteredReviews.length, false);

  buttonControls();
}

function buildBottomLine(bottomLine, totalReviews) {
  var score = bottomLine['average_score'].toFixed(1);
  var stars = parseFloat((Math.round(score * 2) / 2).toFixed(1));
  var bottomLineTotal = bottomLine['total_review'];
  var starImgSrc = getStars(stars);

  // HTML for bottom line score
  var bottomLineHtml = `<span>${score}</span>
      <div class="d-inline-block">
        <img src="${starImgSrc}" width="175" height="35" alt="${stars} stars" />
        <span>${bottomLineTotal} Reviews</span>
      </div>
      <br />
      <button type="button" id="write-review" class="cta">Write a Review</button>`;

  var totalHtml = `<p class="title"><strong>${totalReviews} ${totalReviews == 1 ? "Review" : "Reviews"}</strong></p>`;

  $('#bottom-line').append(bottomLineHtml);
  $('#reviews-container').prepend(totalHtml);

  // HTML for header bottom line score **requires GF hero section**
  if (firstLoad == true) {
    var starsHtml = `<img src="${starImgSrc}" width="175" height="35" alt="${stars} stars" />`;
    var buttonText = `${bottomLineTotal} Reviews`;

    $('.hero-reviews img').remove();
    $('.hero-reviews').prepend(starsHtml);
    $('.hero-reviews a').text(buttonText);

    firstLoad = false;
  }
}

function buildReview(review) {
  // Maximum length of review content (character count)
  var maxLength = 375;
  var title = review['title'];
  var stars = review['score'];
  var content = review['content'];
  var extraContent = "";
  var reviewer = review['user']['display_name'];
  var initial = reviewer.slice(0, 1);
  var verified = review["verified_buyer"];
  var timestamp = new Date(review['created_at']);
  var date = (timestamp.getMonth() + 1) + '/' + timestamp.getDate() + '/' + timestamp.getFullYear().toString().slice(2);
  var images = false;
  var imageHtml = "";
  var starImgSrc = getStars(stars);
  var svgCheckMark = `<svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path fill="currentColor"
      d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z">
    </path>
  </svg>`;
  if (review.hasOwnProperty('images_data') && review['images_data'] != null) {
    images = true;
  }

  if (images) {
    var imageNumber = review["images_data"].length;
    for (x = 0; x < imageNumber; x++) {
      imageHtml = imageHtml + `<a href=\"#review-popup\"
                  onclick=\"openModal(this)\"
                  data-lity
                  data-src=\"${review["images_data"][x]["original_url"]}\"
                  data-reviewer=\"${reviewer}\"
                  data-initial=\"${initial}\"
                  data-verified=\"${verified}\"
                  data-date=\"${date}\"
                  data-score=\"${stars}\"
                  data-title=\"${title}\"
                  data-content=\"${content}\">
                  <img src=\"${review["images_data"][x]["thumb_url"]}\" alt=\"Customer Image\" />
              </a>`;
    }
  }

  if (content.length >= maxLength) {
    trimmedContent = content.slice(0, content.lastIndexOf(" ", maxLength));
    var extraContent = content.slice(trimmedContent.length);
    content = trimmedContent.replace(/([.,\/#!$%\^&\*;:{}=\-_`~()\]\[])+$/g, "") + "<a class=\"read-more\" href=\"javascript:void(0);\">...Read More</a>";
  }

  // HTML for each review
  var reviewHtml = `<article aria-label="${title}">
  <div class="icon-container">
      <div>
          <span>${initial}</span>
          ${verified ? svgCheckMark : ''}
      </div>
      ${verified ? '<span class="d-none d-md-block">Verified Buyer</span>' : ''}
  </div>
  <header>
      <p><span>${reviewer}</span><br class="d-none d-md-block" />${date}</p>
      <img src="${starImgSrc}" width="175" height="35" alt="${stars} stars" />
      <span>${productName}</span>
  </header>
  <div class="clear d-md-none"></div>
  <div class="article-content">
      <h2>${title}</h2>
      <p class="body1">${content} ${extraContent.length > -1 ? '<span class="extra-content">' + extraContent + ' <a class=\"read-less\" href=\"javascript:void(0);\">Read Less</a></span>' : ''}</p>
      ${images ? '<div>' + imageHtml + '<div class="clear"></div></div>' : ''}
  </div>
  <div class="clear"></div>
</article>`;

  $('#reviews-container').append(reviewHtml);
}

function buildNoReviews() {
  var noReviewMessage = `<div class=\"text-center no-reviews\">
          <p class=\"body1\">Sorry, no reviews match your criteria.<br />Clear or modify your filters and try again.</p>
          <br /><a href=\"javascript:void(0);\" onclick=\"resetAll()\">Clear All Filters</a>
      </div>`;

  $('#reviews-container').append(noReviewMessage);
}

function buildFailure() {
  var failureMessage = `<div class=\"text-center no-reviews\">
          <p>Sorry, there has been an error.</p>
          <a href=\"javascript:void(0);\" onclick=\"resetAll()\">Try Again</a>
      </div>`;

  $('#ajax-loading').hide();
  $('#reviews-container').append(failureMessage);
}

function buildPagination(page, totalReviews, searchOrFilter) {
  var totalPages = Math.ceil(totalReviews / perPage);
  pagination = totalPages > 1 ? true : false;
  var paginationList = "";
  var pageStart = 1;

  if (pagination) {
    // Responsive pagination
    if ($(window).width() > 768) {
      if (totalPages > 9 && totalPages - page < 4) {
        pageStart = totalPages - 8;
      } else if (totalPages > 9) {
        pageStart = Math.max(1, page - 4)
      }
      var pageEnd = Math.min(totalPages, pageStart + 8);
    } else {
      if (totalPages > 5 && totalPages - page < 2) {
        pageStart = totalPages - 4;
      } else if (totalPages > 5) {
        pageStart = Math.max(1, page - 2)
      }
      var pageEnd = Math.min(totalPages, pageStart + 4);
    }

    var prevPage = Math.max(1, page - 1);
    var nextPage = Math.min(totalPages, parseInt(page) + 1);
    for (i = pageStart; i <= pageEnd; i++) {
      paginationList = paginationList + `<li><a ${i == page ? 'class="current-page"' : ''} href=\"#${i}\">${i}</a></li>`;
    }

    var paginationHtml = `<ul>
          <li><a href="#${prevPage}"><i class="fas fa-chevron-left fa-lg" aria-hidden="true"></i><span class="sr-only">Previous Page</span></a></li>
          ${paginationList}
          <li><a href="#${nextPage}"><i class="fas fa-chevron-right fa-lg" aria-hidden="true"></i><span class="sr-only">Next Page</span></a></li>
      </ul>`;
    $('#pagination').append(paginationHtml);

    $('#pagination ul a').on('click', function () {
      document.getElementById('rating-filter').scrollIntoView({
        // behavior: 'smooth',
        block: 'center'
      });
      page = $(this).attr('href').split('#')[1];
      stars = $('#rating-filter').val();
      media = $('#media-filter').val();

      if (searchOrFilter == "filter") {
        resetContent().then(setTimeout(function () {
          getSiteReviewsAndFilter(page, stars, media, searchStr);
        }, 10));
      }
      else if (searchOrFilter == "product") {
        resetContent().then(setTimeout(function () {
          getProductReviews(productSku, page, stars);
        }, 10));
      }
      else if (searchOrFilter == "filtered_product") {
        resetContent().then(setTimeout(function () {
          getProductReviewsAndFilter(productSku, page, stars, media, searchStr, false);
        }, 10));
      }
      else {
        getSiteReviews(page, stars);
      }
    });
  }

  $(window).resize(function () {
    if (pagination) {
      $('#pagination').children().remove();
      clearTimeout($.data(this, 'resizeTimer'));
      $.data(this, 'resizeTimer', setTimeout(function () {
        buildPagination(page, totalReviews, searchOrFilter);
      }, 250));
    }
  });
}

function selectProduct(el) {
  page = 1;
  if ($(el).attr('value') == "site" || $(el).val() == "site") {
    productSku = "site";
    productName = "";
    resetContent().then(setTimeout(function () {
      getSiteReviews(page, stars);
    }, 10));
  } else {
    productSku = $(el).is('button') ? $(el).attr('value') : productSku = $(el).val();
    productName = $(el).is('button') ? $(el).text() : productName = $(el).children('option:selected').text();;
    resetContent().then(setTimeout(function () {
      getProductReviews(productSku, page, stars);
    }, 10));
  }
  resetFilters();
  resetSearch();
  $('#product-tabs button').removeClass('active').removeAttr('disabled');
  $('#product-tabs button[value="' + productSku + '"]').addClass('active').attr('disabled', true);
  $('#product-filter').val(productSku);
  history.pushState("", document.title, window.location.pathname);
}

function openModal(el) {
  var imgSrc = $(el).data('src');
  var reviewer = $(el).data('reviewer');
  var initial = $(el).data('initial');
  var verified = $(el).data('verified');
  var date = $(el).data('date');
  var stars = $(el).data('score');
  var starImgAlt = stars + " stars";
  var title = $(el).data('title');
  var content = $(el).data('content');
  var starImgSrc = getStars(stars);

  $('#popup-img').attr('src', imgSrc);
  $('#popup-initial').text(initial);
  if (verified) {
    $('#popup-verified').show();
  } else {
    $('#popup-verified').hide();
  }
  $('#popup-reviewer-date').html('<span>' + reviewer + '</span>' + date);
  $('#popup-star-img').attr('src', starImgSrc);
  $('#popup-star-img').attr('alt', starImgAlt);
  $('#popup-title').text(title);
  $('#popup-content').text(content);

  carouselControls(el);

  $('.popup-prev').on('click', function () {
    el = $(el).prev('a');
    imgSrc = $(el).data('src');
    $('#popup-img').attr('src', imgSrc);
    carouselControls(el);
  });
  $('.popup-next').on('click', function () {
    el = $(el).next('a');
    imgSrc = $(el).data('src');
    $('#popup-img').attr('src', imgSrc);
    carouselControls(el);
  });
}

function getStars(stars) {
  switch (stars) {
    case 1:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-1.png?v=136266830157744000721769100794"
      break;
    case 1.5:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-1-5.png?v=5311670588863682501769100793"
      break;
    case 2:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-2.png?v=36130405363660669191769100794"
      break;
    case 2.5:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-2-5.png?v=148743486608173680971769100794"
      break;
    case 3:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-3.png?v=2179115489058421971769100792"
      break;
    case 3.5:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-3-5.png?v=168732676748227592661769100791"
      break;
    case 4:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-4.png?v=65388273012463091611769100793"
      break;
    case 4.5:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-4-5.png?v=3454160130687712641769100792"
      break;
    case 5:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-5.png?v=40253685856238167181769100793"
      break;
    default:
      var starsImg = "//www.bistromd.com/cdn/shop/t/200/assets/yotpo-stars-5.png?v=40253685856238167181769100793"
  }
  return starsImg;
}

function carouselControls(el) {
  if ($(el).prev('a').length) {
    $('.popup-prev').show();
  } else {
    $('.popup-prev').hide();
  }

  if ($(el).next('a').length) {
    $('.popup-next').show();
  } else {
    $('.popup-next').hide();
  }
}

function buttonControls() {
  $('#write-review').on('click', function () {
    $('#write-review-container h2').text('Write a Review');
    $('#write-review-container').slideToggle();
    setTimeout(() => {
      $('#write-review-container .yotpo-submit').on('click', function () {
        setTimeout(() => {
          document.getElementById('thank-you-anchor').scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 250);
      });
      $('#write-review-container .yotpo-thank-you .yotpo-icon-btn').on('click', function () {
        $('#write-review-container').remove();
        $('#write-review').remove();
      });
    }, 1000);
  });

  $('.read-more').on('click', function () {
    $(this).hide();
    $(this).parent('p').find('span.extra-content').fadeIn();
    $(this).parents('p').find('a.read-less').show();
  });
  $('.read-less').on('click', function () {
    $(this).hide();
    $(this).parent('span.extra-content').fadeOut();
    setTimeout(() => {
      $(this).parents('p').find('a.read-more').fadeIn();
    }, 400);
  });

  if (stars > 0 || media > 0 || searchStr.length) {
    $('#clear-filters').show();
  } else {
    $('#clear-filters').hide();
  }
}

function resetAll() {
  resetFilters();
  resetSearch();
  $('#product-tabs button').removeClass('active').removeAttr('disabled');
  $('#product-tabs button[value="site"]').addClass('active').attr('disabled', true);
  $('#product-filter').val('site');
  productName = "";
  productSku = "site";
  getSiteReviews(1, "");
}

function resetFilters() {
  $('#rating-filter').css({ 'font-size': '1rem', 'color': '#222' });
  $('#rating-filter').val("");
  $('#media-filter').val("");
  stars = "";
  media = "";
}

function resetSearch() {
  $('#search-filter').val("");
  searchStr = "";
}

async function resetContent() {
  $('#bottom-line').children().remove();
  $('#reviews-container').children().remove();
  $('#pagination').children().remove();
  $('#main-content').hide();
  $('#ajax-loading').show();
  $('#write-review-container').hide();
}

/*
* Knuth-Morris-Pratt string matcher (JavaScript)
*
* Copyright (c) 2014 Project Nayuki. (MIT License)
* https://www.nayuki.io/page/knuth-morris-pratt-string-matching
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of
* this software and associated documentation files (the "Software"), to deal in
* the Software without restriction, including without limitation the rights to
* use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
* the Software, and to permit persons to whom the Software is furnished to do so,
* subject to the following conditions:
* - The above copyright notice and this permission notice shall be included in
*   all copies or substantial portions of the Software.
* - The Software is provided "as is", without warranty of any kind, express or
*   implied, including but not limited to the warranties of merchantability,
*   fitness for a particular purpose and noninfringement. In no event shall the
*   authors or copyright holders be liable for any claim, damages or other
*   liability, whether in an action of contract, tort or otherwise, arising from,
*   out of or in connection with the Software or the use or other dealings in the
*   Software.
*/

// Searches for the given pattern string in the given text string using the Knuth-Morris-Pratt string matching algorithm.
// If the pattern is found, this returns the index of the start of the earliest match in 'text'. Otherwise -1 is returned.
function kmpSearch(pattern, text) {
  if (pattern.length == 0)
    return 0;  // Immediate match

  // Compute longest suffix-prefix table
  var lsp = [0];  // Base case
  for (var i = 1; i < pattern.length; i++) {
    var j = lsp[i - 1];  // Start by assuming we're extending the previous LSP
    while (j > 0 && pattern.charAt(i) != pattern.charAt(j))
      j = lsp[j - 1];
    if (pattern.charAt(i) == pattern.charAt(j))
      j++;
    lsp.push(j);
  }

  // Walk through text string
  var j = 0;  // Number of chars matched in pattern
  for (var i = 0; i < text.length; i++) {
    while (j > 0 && text.charAt(i) != pattern.charAt(j))
      j = lsp[j - 1];  // Fall back in the pattern
    if (text.charAt(i) == pattern.charAt(j)) {
      j++;  // Next char matched, increment position
      if (j == pattern.length)
        return i - (j - 1);
    }
  }
  return -1;  // Not found
}